import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	icon: ReactNode;
	rowColor: string;
	chipColor: string;
	title: string;
	titleSuffix?: string;
	description: string;
};

export const RentPhaseRow: FC<Props> = ({
	icon,
	rowColor,
	chipColor,
	title,
	titleSuffix,
	description,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1.25}
			px={1.5}
			py={1}
			bgcolor={rowColor}
			borderRadius={theme.radii.lg}
		>
			<Stack
				alignItems="center"
				justifyContent="center"
				flexShrink={0}
				mt={0.25}
				bgcolor={chipColor}
				borderRadius={theme.radii.lg}
				width={32}
				height={32}
			>
				{icon}
			</Stack>
			<Stack flex={1} minWidth={0}>
				<Typography variant="caption" fontWeight={600}>
					{title}
					{titleSuffix && (
						<Typography component="span" variant="hint">
							{` · ${titleSuffix}`}
						</Typography>
					)}
				</Typography>
				<Typography variant="caption" color={theme.palette.grey[600]} mt={0.25}>
					{description}
				</Typography>
			</Stack>
		</Stack>
	);
};
